if ( typeof WishlistForm !== 'function' ) {
	class WishlistForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyWishlistItems();
		}

		ajaxifyWishlistItems(){
			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-wishlist-item]').forEach(item=>{
				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateWishlistQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateWishlistQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}
			})
		}

		updateWishlistQty(item, newQty){
			let alert = null;
			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch('/wishlist/change', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = response.description || response.message;
					}
					return fetch('?section_id=helper-wishlist');
				})
				.then(response => response.text())
				.then(text => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const wishlistFormInnerHTML = sectionInnerHTML.getElementById('AjaxWishlistForm').innerHTML;
					const wishlistSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxWishlistSubtotal').innerHTML;

					const wishlistItems = document.getElementById('AjaxWishlistForm');
					wishlistItems.innerHTML = wishlistFormInnerHTML;
					wishlistItems.ajaxifyWishlistItems();

					document.querySelectorAll('[data-header-wishlist-count]').forEach(elm=>{
						elm.textContent = wishlistItems.querySelector('[data-wishlist-count]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxWishlistSubtotal').innerHTML = wishlistSubtotalInnerHTML;
							
					const event = new Event('wishlist-updated');
					this.dispatchEvent(event);
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = 'An error occurred while updating the wishlist.';
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}
	} 

	if ( typeof customElements.get('wishlist-form') == 'undefined' ) {
		customElements.define('wishlist-form', WishlistForm);
	}
}

if ( typeof WishlistProductQuantity !== 'function' ) {
	class WishlistProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeWishlistInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeWishlistInput.bind(this));
		}
		changeWishlistInput(){
			setTimeout(()=>{
				document.getElementById('AjaxWishlistForm').updateWishlistQty(this.closest('[data-js-wishlist-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

	if ( typeof customElements.get('wishlist-product-quantity') == 'undefined' ) {
		customElements.define('wishlist-product-quantity', WishlistProductQuantity);
	}
}

if ( ! window.refreshWishlist ) {
	window.refreshWishlist = () => {
		fetch('?section_id=helper-wishlist')
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const wishlistFormInnerHTML = sectionInnerHTML.getElementById('AjaxWishlistForm').innerHTML;
				const wishlistSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxWishlistSubtotal').innerHTML;

				const wishlistItems = document.getElementById('AjaxWishlistForm');
				wishlistItems.innerHTML = wishlistFormInnerHTML;
				wishlistItems.ajaxifyWishlistItems();

				document.querySelectorAll('[data-header-wishlist-count]').forEach(elm=>{
					elm.textContent = wishlistItems.querySelector('[data-wishlist-count]').textContent;
				});

				document.getElementById('AjaxWishlistSubtotal').innerHTML = wishlistSubtotalInnerHTML;
				if ( document.querySelector('[data-js-site-wishlist-sidebar]') ) {
					document.querySelector('[data-js-site-wishlist-sidebar]').show();
				}

				const event = new Event('wishlist-updated');
				document.dispatchEvent(event);
			})
	}
}
